import React, { useEffect, useMemo, useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import BaseFilter, {
  FilterTypeEnum,
} from '../../../components/base/BaseFilter';
import { ArrayStringData } from '../../../utils';
import { connect } from 'react-redux';
import { CampaignType, COUPON_REDEMPTION_METHOD, COUPON_SET_MEDIUM, COUPON_SET_TYPES, EarningRuleRewardType, EarningRuleType, MessageBackendChannel, MessageChannel, SEGMENT_TYPE } from '../../../config/CustomEnums';
import './Filter.scss';

const mapPropsToState = (state) => ({
  levelList: state.levels.levelList,
  brandList: state.brand.brandList,
  checkedBrandList: state.brand.checkedList,
  segmentList: state.segments.notPagedAllList,
});
function Filter({
  levelList,
  brandList,
  checkedBrandList,
  segmentList,
  backAction = () => { },
  displayIn = null,
  useNewFilter = false,
  isTicket = false,
}) {
  const location = useLocation();

  // collapsed or expanded
  const [campaignSectionCollapsed, setCampaignSectionCollapsed] = useState(false);
  const [couponSectionCollapsed, setCouponSectionCollapsed] = useState(false);
  const [earningSectionCollapsed, setEarningSectionCollapsed] = useState(false);

  // campaign filter
  const parsedSearch = queryString.parse(location.search);
  const searchType = parsedSearch['type'] || '';
  const searchPublishStatus = parsedSearch['status'] || '';
  const searchExpiredStatus = parsedSearch['expired'] || '';
  const searchMessageChannel = parsedSearch['message_channel'] || '';
  const searchBrand = parsedSearch['brand'] || '';
  const searchActivePeriod = parsedSearch['active_period'] || '';
  const searchVisablePeriod = parsedSearch['visable_period'] || '';

  const searchTargetCustomer = parsedSearch['target_customer'] || '';
  const searchStaticSegments = parsedSearch['staticSegmentsIn'] || '';
  const searchDynamicSegments = parsedSearch['dynamicSegmentsIn'] || '';
  const searchLevels = parsedSearch['levelsIn'] || '';
  const searchIsBirthdayRecurringCampaign = parsedSearch['recurring_campaign_for_birthday'] || '';

  const [staticSegmentList, dynamicSegmentList] = useMemo(() => {
    if (!segmentList?.length > 0) {
      return [[], []]
    }
    const staticSegment = segmentList?.filter(item => item?.segmentType === SEGMENT_TYPE.STATIC) || []
    const dynamicSegment = segmentList?.filter(item => item?.segmentType === SEGMENT_TYPE.DYNAMIC) || []
    return [staticSegment, dynamicSegment]
  }, [segmentList])

  const [type, setType] = useState(searchType);
  const [status, setStatus] = useState(
    ArrayStringData(searchPublishStatus)
  );
  const [expired, setExpired] = useState(searchExpiredStatus);
  const [messageChannel, setMessageChannel] = useState(
    ArrayStringData(searchMessageChannel),
  );
  const [brand, setBrand] = useState([]);
  const [activePeriod, setActivePeriod] = useState(searchActivePeriod);
  const [visablePeriod, setVisablePeriod] = useState(searchVisablePeriod);
  const [targetCustomer, setTargetCustomer] = useState(searchTargetCustomer);
  const [levels, setLevels] = useState(ArrayStringData(searchLevels));

  const [dynamicSegments, setDynamicSegments] = useState(ArrayStringData(searchDynamicSegments));
  const [staticSegments, setStaticSegments] = useState(ArrayStringData(searchStaticSegments));
  const [isBirthdayRecurring, setIsBirthdayRecurring] = useState(searchIsBirthdayRecurringCampaign)


  // coupon template filter
  const searchCouponMedium = parsedSearch['coupon_medium'] || '';
  const searchOutOfStock = parsedSearch['coupon_out_of_stock'] || '';
  const searchCouponExpired = parsedSearch['coupon_expired'] || '';
  const searchCouponIsActive = parsedSearch['coupon_is_active'] || '';
  const searchExpiredDateType = parsedSearch['expired_date'] || '';
  const searchExpiredDate = parsedSearch['absolute'] || '';
  const searchRelativeDay = parsedSearch['relative_day'] || '';
  const searchCouponType = parsedSearch['coupon_type'] || '';
  const searchRedemptionMethod = parsedSearch['redemption_method'] || '';

  const [couponMedium, setCouponMedium] = useState(ArrayStringData(searchCouponMedium));
  const [outOfStock, setOutOfStock] = useState(searchOutOfStock);
  const [couponExpired, setCouponExpired] = useState(searchCouponExpired);
  const [couponIsActive, setCouponIsActive] = useState(searchCouponIsActive);
  const [expiredDateType, setExpiredDateType] = useState(searchExpiredDateType);
  const [expiredDate, setExpiredDate] = useState(searchExpiredDate);
  const [relativeDay, setRelativeDay] = useState(searchRelativeDay);
  const [couponType, setCouponType] = useState(ArrayStringData(searchCouponType));
  const [offlineRedemptionMethod, setOfflineRedemptionMethod] = useState(ArrayStringData(searchRedemptionMethod));

  // earning rule filter
  const searchEarningRuleType = parsedSearch['earning_rule_type'] || '';
  const searchEarningRuleRewardType = parsedSearch['earning_rule_reward_type'] || '';

  const [earningRuleType, setEarningRuleType] = useState(searchEarningRuleType);
  const [earningRuleRewardType, setEarningRuleRewardType] = useState(
    ArrayStringData(searchEarningRuleRewardType),
  );

  useEffect(() => {
    if (searchBrand && checkedBrandList) {
      setBrand(...brand, checkedBrandList)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedBrandList])

  const content = [
    ...(['STAMP_LIST', 'MESSAGE_LIST'].includes(displayIn) ?
      [] : [{
        title: 'Type',
        data: [
          { pk: CampaignType.couponsCampaign, name: 'Coupon' },
          { pk: CampaignType.earningRulesCampaign, name: 'Earning' },
        ],
        value: type,
        setValue: setType,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      }]),
    {
      title: 'Recurring campaign for birthday',
      data: [
        { name: 'No', pk: 'false' },
        { name: 'Yes', pk: 'true' },
      ],
      value: isBirthdayRecurring,
      setValue: setIsBirthdayRecurring,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Message channel',
      data: [
        {
          name: MessageChannel.all,
          pk: MessageBackendChannel.all,
        },
        {
          name: MessageChannel.allWhatsapp,
          pk: MessageBackendChannel.allWhatsapp,
        },
        {
          name: MessageChannel.allWechat,
          pk: MessageBackendChannel.allWechat,
        },
        {
          name: MessageChannel.push,
          pk: MessageBackendChannel.push,
        },
        {
          name: MessageChannel.email,
          pk: MessageBackendChannel.email,
        },
        {
          name: MessageChannel.sms,
          pk: MessageBackendChannel.sms,
        },
        {
          name: MessageChannel.whatsapp,
          pk: MessageBackendChannel.whatsapp,
        },
        {
          name: MessageChannel.wechat,
          pk: MessageBackendChannel.wechat,
        },
        {
          name: MessageChannel.inbox,
          pk: MessageBackendChannel.inbox,
        },
      ],
      value: messageChannel,
      setValue: setMessageChannel,
      component: FilterTypeEnum.choice,
    },
    {
      filterTitle: 'Brand',
      data: brandList,
      value: brand,
      setValue: setBrand,
      placeholder: 'Search by brand name',
      loadMoreAction: 'brand/getCurrentPageBrands',
      filterAction: 'brand/getCurrentPageBrands',
      customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
      defaultFilter: {
        isSimpleNode: true,
        noLoading: true,
      },
      component: FilterTypeEnum.multipleSelectorDropdown,
    },
    {
      title: 'Expired',
      data: [
        { name: 'Unexpired', pk: 'false' },
        { name: 'Expired', pk: 'true' },
      ],
      value: expired,
      setValue: setExpired,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Status',
      data: [
        { name: 'Draft', pk: 'DRAFT' },
        { name: 'Pending For Approval', pk: 'PENDING' },
        { name: 'Published', pk: 'PUBLISHED' },
      ],
      value: status,
      setValue: setStatus,
      component: FilterTypeEnum.choice,
      className: 'fit-content-height-area'
    },
    {
      title: 'Target customer',
      data: [
        {
          name: 'Dynamic segment',
          pk: 'dynamicSegmentsIn',
          subComponment: {
            data: dynamicSegmentList,
            value: dynamicSegments,
            setValue: setDynamicSegments,
            component: FilterTypeEnum.choice,
            className: 'filter-list-items-sub-area',
          },
        },
        {
          name: 'Static segment',
          pk: 'staticSegmentsIn',
          subComponment: {
            data: staticSegmentList,
            value: staticSegments,
            setValue: setStaticSegments,
            component: FilterTypeEnum.choice,
            className: 'filter-list-items-sub-area',
          },
        },
        {
          name: 'Level',
          pk: 'levelsIn',
          subComponment: {
            data: levelList,
            value: levels,
            setValue: setLevels,
            component: FilterTypeEnum.choice,
            className: 'filter-list-items-sub-area',
          },
        },
      ],
      value: targetCustomer,
      setValue: setTargetCustomer,
      component: FilterTypeEnum.singleChoiceTargetCustomer,
    },
    {
      title: 'Active period',
      value: activePeriod,
      setValue: setActivePeriod,
      component: FilterTypeEnum.dateRange,
    },
    {
      title: 'Visible period',
      data: [
        { name: 'Inbox', pk: 'inbox' },
        { name: 'Push', pk: 'push' },
      ],
      value: visablePeriod,
      setValue: setVisablePeriod,
      component: FilterTypeEnum.dateRange,
    },
  ];

  const couponSectionContent = {
    sectionName: isTicket ? "Ticket related" : "Coupon related",
    customSectionClassName: "campaign-filter-section",
    content: [
      {
        hide: isTicket,
        title: 'Coupon medium',
        data: [
          { name: 'Online only', pk: COUPON_SET_MEDIUM.ONLINE },
          { name: 'Offline only', pk: COUPON_SET_MEDIUM.OFFLINE },
          { name: 'Online or offline', pk: COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE },
        ],
        value: couponMedium,
        setValue: setCouponMedium,
        component: FilterTypeEnum.choice,
        className: 'fit-content-height-area',
      },
      {
        customFilterKey: 'coupon_out_of_stock',
        title: 'Out of stock',
        data: [
          { name: 'Out of stock', pk: 'true' },
          { name: 'Have stock', pk: 'false' },
        ],
        value: outOfStock,
        setValue: setOutOfStock,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        customFilterKey: 'coupon_expired',
        title: 'Expired',
        data: [
          { name: 'Expired', pk: 'true' },
          { name: 'Unexpired', pk: 'false' },
        ],
        value: couponExpired,
        setValue: setCouponExpired,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        customFilterKey: 'coupon_is_active',
        title: 'Status',
        data: [
          { name: 'Active', pk: 'true' },
          { name: 'Inactive', pk: 'false' },
        ],
        value: couponIsActive,
        setValue: setCouponIsActive,
        component: FilterTypeEnum.singleChoiceSegment,
      },
      {
        title: 'Expired date',
        data: [
          { name: 'All time', pk: 'allTime', subComponment: null },
          {
            name: 'Time Range',
            pk: 'absolute',
            subComponment: {
              value: expiredDate,
              setValue: setExpiredDate,
              component: FilterTypeEnum.dateRange,
            },
          },
          {
            name: 'Since acquiring',
            pk: 'relativeDay',
            subComponment: {
              value: relativeDay,
              setValue: setRelativeDay,
              component: FilterTypeEnum.input,
            },
          },
        ],
        value: expiredDateType,
        setValue: setExpiredDateType,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        hide: isTicket,
        title: 'Coupon type',
        data: [
          { name: 'System generated', pk: COUPON_SET_TYPES.SYSTEM_GENERATED },
          {
            name: 'Import existing coupon',
            pk: COUPON_SET_TYPES.IMPORT_EXISTING_COUPON,
          },
        ],
        value: couponType,
        setValue: setCouponType,
        component: FilterTypeEnum.choice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Redemption method',
        data: [
          {
            name: 'Merchant app scan Coupon QR code',
            pk: COUPON_REDEMPTION_METHOD.MERCHANT_APP_SCAN_COUPON_QR_CODE,
          },
          {
            name: 'Users scan Store QR code',
            pk: COUPON_REDEMPTION_METHOD.USERS_SCAN_STORE_QR_CODE,
          },
          {
            name: 'Merchant staff input store code only',
            pk: COUPON_REDEMPTION_METHOD.INPUT_STORE_STAFF_CODE,
          },
          {
            name: 'Sales system update',
            pk: COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE,
          },
        ].filter(option => {
          if (isTicket && option.pk === COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE) {
            return false;
          };
          return true;
        }),
        value: offlineRedemptionMethod,
        setValue: setOfflineRedemptionMethod,
        component: FilterTypeEnum.choice,
        className: 'fit-content-height-area',
      },
    ],
    collapsed: couponSectionCollapsed,
    setCollapsed: setCouponSectionCollapsed,
  };

  const earningRuleSectionContent = {
    sectionName: "Rule related",
    customSectionClassName: "campaign-filter-section",
    content: [
      {
        customFilterKey: 'earning_rule_type',
        title: 'Type',
        data: [
          { pk: EarningRuleType.qrCodeScanning, name: 'QR Code' },
          { pk: EarningRuleType.gpsCheckIn, name: 'GPS' },
          { pk: EarningRuleType.memberReferral, name: 'Referral' },
          { pk: EarningRuleType.generalPurchase, name: 'Purchase' },
          { pk: EarningRuleType.newMember, name: 'New Member' },
          { pk: EarningRuleType.birthday, name: 'Birthday' },
          { pk: EarningRuleType.fillingForm, name: 'Webhook' },
          { pk: EarningRuleType.levelUpgrade, name: 'Level Upgrade' },
        ],
        value: earningRuleType,
        setValue: setEarningRuleType,
        component: FilterTypeEnum.singleChoice,
      },
      {
        customFilterKey: 'earning_rule_reward_type',
        title: 'Reward type',
        data: [
          { name: 'Coupons', pk: EarningRuleRewardType.coupons },
          { name: 'Points', pk: EarningRuleRewardType.points },
          { name: 'Stamps', pk: EarningRuleRewardType.stamps },
        ],
        value: earningRuleRewardType,
        setValue: setEarningRuleRewardType,
        component: FilterTypeEnum.choice,
        className: 'fit-content-height-area',
      },
    ],
    collapsed: earningSectionCollapsed,
    setCollapsed: setEarningSectionCollapsed,
  };

  if (!useNewFilter) {
    return <BaseFilter content={content} backAction={backAction} />
  }

  return <BaseFilter
    content={content}
    backAction={backAction}
    customFilterClassName="campaign-filter-container"
    sectionName={isTicket ? "Event related" : "Campaign related"}
    customSectionClassName="campaign-filter-section"
    collapsed={campaignSectionCollapsed}
    setCollapsed={setCampaignSectionCollapsed}
    otherSectionContent={[
      couponSectionContent,
      ...(isTicket ? [] : [earningRuleSectionContent])
    ]}
  />;
}

export default connect(mapPropsToState)(Filter);
